<template>
  <div class="laypanel">
    <el-tabs v-model="kqtab" type="card" style="height: 200px; margin: 40px;">
      <el-tab-pane label="卡券配置" name="kqgl">
        <div>
          <el-button type="primary" icon="el-icon-search" style="margin-top: 10px; margin-left: 5px;" @click="querkq">查询卡券</el-button>
          <el-button type="primary" icon="el-icon-plus" style="margin-top: 10px; margin-left: 10px;" @click="addkq">新增卡券</el-button>
          <el-button type="success" icon="el-icon-edit-outline" style="margin-top: 10px; margin-left: 10px;" @click="exportkqexcel">导出Excel</el-button>
        </div>
        <el-row class="querypanel" style="margin-top: 20px;">
          <el-table
            stripe
            :header-cell-style="{'text-align':'center'}"
            :data="kqdata"
            ref="multipleTable">
            <el-table-column
              prop="id"
              width="50"
              label="ID">
            </el-table-column>
            <el-table-column
              prop="title"
              label="卡券标题">
            </el-table-column>
            <el-table-column
              prop="des"
              label="描述">
            </el-table-column>
            <el-table-column
              prop="price"
              label="价值">
            </el-table-column>
            <el-table-column
              label="卡券背景">
              <template slot-scope="scope">
                <div v-if="scope.row.img !== undefined">
                  <img :src="scope.row.img" class="avatarimg6">
                </div>
                <div v-else>
                  {scope.row.img}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑卡券" placement="top-start">
                  <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="editkq(scope.$index, kqdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="卡券投放" placement="top-start">
                  <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="fpkq(scope.$index, kqdata)"></i>
                </el-tooltip>
                <el-tooltip class="item"  style="margin-left: 10px;" effect="dark" content="删除卡券" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delkq(scope.$index, kqdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="已投放卡券(只允许作废)" name="ytfkq">
        <el-table
          stripe
          :header-cell-style="{'text-align':'center'}"
          :data="allkqdata"
          ref="multipleTable">
          <el-table-column
            prop="ownphone"
            label="拥有人"
          >
          </el-table-column>
          <el-table-column
            prop="usernick"
            label="昵称"
          >
          </el-table-column>
          <el-table-column
            prop="goodsid"
            label="可用商品ID"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="卡券名称"
          >
          </el-table-column>
          <el-table-column
            prop="price"
            label="金额"
          >
          </el-table-column>
          <el-table-column
            prop="startdate"
            label="开始时间"
          >
          </el-table-column>
          <el-table-column
            prop="enddate"
            label="截止时间"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="50"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="作废卡券" placement="top-start">
                <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="zfkq(scope.$index, allkqdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="卡券管理" :visible.sync="viskqedit">
      <div class="querypanel">
        <el-row>
          <el-form ref="form"  label-width="120px" label-position="left">
            <el-form-item label="标题:">
              <el-input v-model="kqtitle"></el-input>
            </el-form-item>
            <el-form-item label="卡券值:">
              <el-input v-model="kqprice"></el-input>
            </el-form-item>
            <el-form-item label="描述:">
              <el-input v-model="kqdes"></el-input>
            </el-form-item>
            <el-form-item label="上传卡背景" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                drag
                action="https://api.sqnetsoft.cn/ossupload/uploadoss"
                :data= ticketupparms
                :on-success="OnTicketSuccess">
                <img v-if="ticketbackurlok" :src="ticketbackurl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <div class="savebasepanel">
            <el-button  @click="addnewticket">添加新卡券</el-button>
            <el-button  @click="savenewticket">保存修改</el-button>
          </div>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog title="分配优惠券" :visible.sync="visuserlist">
      <div class="querypanel">
        <el-form ref="form"  label-width="120px" label-position="left">
        <el-row>
          <el-col :span="12">
              <el-form-item label="生效日期:">
                <el-date-picker
                  v-model="bysxdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
          </el-col>
        </el-row>
        <el-collapse v-model="activeNames">
            <el-collapse-item title="分配给小程序用户" name="1">
              <el-row>
                <el-form-item label="分配给:">
                  <el-form ref="form" :inline="true" label-width="120px" label-position="left">
                    <el-form-item label="用户昵称:">
                      <el-input v-model="usernick"></el-input>
                    </el-form-item>
                    <el-form-item label="用户手机:">
                      <el-input v-model="wxuserphone"></el-input>
                    </el-form-item>
                    <el-button  @click="querywxuserbyinfo">快速检索</el-button>
                  </el-form>
                  <el-table
                    stripe
                    :data="query_u_data"
                    :header-cell-style="{'text-align':'center'}"
                    ref="kqtb_userlist">
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      label="头像">
                      <template slot-scope="scope">
                        <div v-if="scope.row.userimg !== undefined">
                          <img :src="scope.row.userimg" class="avatarimg6">
                        </div>
                        <div v-else>
                          {scope.row.userimg}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="usernick"
                      label="昵称">
                    </el-table-column>
                    <el-table-column
                      prop="phone"
                      label="联系方式">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="指定商品" name="2">
              <el-row>
                <el-form-item label="适用商品:">
                  <el-form ref="form" :inline="true" label-width="120px" label-position="left">
                    <el-form-item label="商品名:">
                      <el-input v-model="gname"></el-input>
                    </el-form-item>
                    <el-form-item label="条码:">
                      <el-input v-model="gcode"></el-input>
                    </el-form-item>
                    <el-button  @click="querygoodsbyinfo">快速检索</el-button>
                  </el-form>
                  <el-table
                    fit
                    ref="kqtb_goodslist"
                    :header-cell-style="{'text-align':'center'}"
                    :data="cusgoodsdata"
                  >
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      min-width="30px"
                      prop="id"
                      label="编号"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="产品名称">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-row>
            </el-collapse-item>
        </el-collapse>
        <div style="margin-top: 15px">
          <el-button @click="saveyhqtouser">分配优惠券</el-button>
        </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
import XLSX from 'xlsx'
Vue.prototype.$http = axios
var that
export default {
  name: 'KqMana',
  data () {
    return {
      khid: '',
      activeNames: [],
      usernick: '',
      wxuserphone: '',
      gname: '',
      gcode: '',
      kqtab: 'kqgl',
      kqdata: [],
      ticketupparms: {'bucketname': 'sqpro', 'bucketpath': 'ecomm/member'},
      viskqedit: false,
      kqtitle: '',
      kqprice: '',
      ticketimg: '',
      kqdes: '',
      ticketbackurlok: false,
      ticketbackurl: '',
      visuserlist: false,
      query_u_data: [],
      selticketdata: '',
      bysxdate: '',
      cusgoodsdata: [],
      allkqdata: [],
      curkqdata: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$options.methods.getallkq()
    }
  },
  methods: {
    querygoods () {
      var qstr = {
        whereinfo: " ownphone = '" + localStorage.getItem('phone') + "'",
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/qginfo',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.cusgoodsdata = res.data
          } else {
            that.cusgoodsdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querywxuserbyinfo () {
      var qsubstr = ' LENGTH(openid) = 28'
      if (that.usernick !== '') {
        qsubstr = qsubstr + " and usernick like '%" + that.usernick + "%'"
      }
      if (that.wxuserphone !== '') {
        qsubstr = qsubstr + " and phone like '%" + that.wxuserphone + "%'"
      }
      var sqstr = {
        whereinfo: qsubstr,
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxuser',
        method: 'post',
        data: sqstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.query_u_data = res.data
          } else {
            that.query_u_data = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querygoodsbyinfo () {
      var qsubstr = " ownphone = '" + localStorage.getItem('phone') + "'"
      if (that.gname !== '') {
        qsubstr = qsubstr + " and name like '%" + that.gname + "%'"
      }
      if (that.gcode !== '') {
        qsubstr = qsubstr + " and barcode like '%" + that.gcode + "%'"
      }
      var qstr = {
        whereinfo: qsubstr,
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryginfo',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.cusgoodsdata = res.data
          } else {
            that.cusgoodsdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    queryuserwx () {
      var sqstr = {
        whereinfo: ' LENGTH(openid) = 28',
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querywxuser',
        method: 'post',
        data: sqstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.query_u_data = res.data
          } else {
            that.query_u_data = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    exportkqexcel () {
      // 表名
      var xlsdata = []
      for (var i = 0; i< that.allkqdata.length; i++) {
        var tmpdata = that.allkqdata[i]
        var xlstmp = {
          '卡券类别': tmpdata.typeid,
          '卡券状态': tmpdata.kqstate,
          '卡券标题':tmpdata.title.String,
          '卡券描述': tmpdata.des.String,
          '卡券金额': tmpdata.price.String,
          '卡券图片': tmpdata.cardimg.String,
          '拥有人ID': tmpdata.userid,
          '拥有人姓名': tmpdata.name.String,
          '有效期': tmpdata.startdate.String + '-' + tmpdata.enddate.String,
          '特定消费商品ID': tmpdata.goodsid
        }
        xlsdata.push(xlstmp)
      }
      var ws = XLSX.utils.json_to_sheet(xlsdata);
      /* get binary string as output */
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '卡券信息');
      /* 生成xlsx文件 */
      XLSX.writeFile(wb, '卡券信息.xlsx');
    },
    getallkq: function () {
      var sqstr = {
        whereinfo: " ownphone = '" + localStorage.getItem('phone') + "'",
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/querymemberticket',
        method: 'post',
        data: sqstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.allkqdata = res.data
          } else {
            that.allkqdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    addkq: function () {
      this.viskqedit = true
      this.kqtitle = ''
      this.kqprice = ''
      this.kqdes = ''
      this.ticketimg = ''
      this.ticketbackurlok = false
      this.ticketbackurl = ''
    },
    addnewticket: function () {
      console.log(this.kqtitle)
      console.log(this.kqprice)
      console.log(this.ticketimg)
      if (this.kqtitle !== '' && this.kqprice !== '' && this.ticketimg !== '') {
        var adddata = {
          id: '',
          title: that.kqtitle,
          des: that.kqdes,
          price: that.kqprice,
          img: that.ticketimg,
          cusid: '',
          ownphone: localStorage.getItem('phone')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addticketinfo',
          method: 'post',
          data: adddata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加完毕!'
              })
              that.viskqedit = false
              that.$options.methods.querkq()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '信息不完整!'
        })
      }
    },
    savenewticket: function () {
      if (this.kqtitle !== '' && this.kqprice !== '' && this.ticketimg !== '') {
        var adddata = {
          id: that.selticketdata.id.toString(),
          title: that.kqtitle,
          des: that.kqdes,
          price: that.kqprice,
          img: that.ticketimg,
          cusid: '1',
          ownphone: localStorage.getItem('phone')
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addticketinfo',
          method: 'post',
          data: adddata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '添加完毕!'
              })
              that.viskqedit = false
              that.$options.methods.querkq()
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.$message({
          type: 'info',
          message: '信息不完整!'
        })
      }
    },
    querkq: function () {
      this.fxinfolist = []
      var qstr = {
        whereinfo: " ownphone = '" + localStorage.getItem('phone') + "'",
        limit: '',
        sortinfo: ''
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/queryticketinfo',
        method: 'post',
        data: qstr,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.length > 0) {
            that.kqdata = res.data
          } else {
            that.kqdata = []
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    editkq: function (index, data) {
      var datatmp = data[index]
      console.log(datatmp)
      this.viskqedit = true
      this.selticketdata = datatmp
      this.kqtitle = datatmp.title
      this.kqprice = datatmp.price
      this.kqdes = datatmp.des
      this.ticketimg = datatmp.img
      this.ticketbackurlok = true
      this.ticketbackurl = datatmp.img
    },
    delkq: function (index, data) {
      var selectdata = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cndelticketinfo',
        method: 'post',
        data: {
          id: selectdata.id.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.result === 'success') {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.querkq()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    zfkq: function (index, data) {
      var selectdata = data[index]
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cndelmemberticket',
        method: 'post',
        data: {
          id: selectdata.id.toString()
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.result === 'success') {
            that.$message({
              type: 'success',
              message: '作废成功!'
            })
            that.$options.methods.getallkq()
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    fpkq: function (index, data) {
      var row = data[index]
      console.log(row)
      this.curkqdata = row
      this.visuserlist = true
    },
    saveyhqtouser: function () {
      console.log('给用户分配优惠券')
      var adddatas = []
      var selgdatas = []
      var selarr = []
      if (this.$refs.kqtb_userlist.selection.length > 0) {
        selarr = this.$refs.kqtb_userlist.selection
      } else {
        that.$message.error('必须选择用户')
        return
      }
      window.console.log(selarr)
      var selgoods = []
      if (this.$refs.kqtb_goodslist.selection.length > 0) {
        selgoods = this.$refs.kqtb_goodslist.selection
        window.console.log(selgoods)
        for (let index in selgoods) {
          selgdatas.push(selgoods[index].id)
        }
        selgoods = selgdatas.join(',')
      } else {
        selgoods = ''
      }
      for (let index in selarr) {
        var datatmp = {
          userid: selarr[index].openid,
          typeid: '1',
          ticketid: this.curkqdata.id.toString(),
          goodsid: selgoods,
          startdate: this.bysxdate[0],
          enddate: this.bysxdate[1],
          kqstate: '1',
          cusid: that.khid.toString(),
          ownphone: localStorage.getItem('phone')
        }
        adddatas.push(datatmp)
      }
      that.$http({
        url: 'https://ecommapi.sqnetsoft.cn/paddmemberticket',
        method: 'post',
        data: adddatas,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.visuserlist = false
            that.$options.methods.getallkq()
            that.$message({
              type: 'success',
              message: '添加完毕'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    OnTicketSuccess (res, rfile, fileList) {
      if (res.success) {
        this.ticketbackurlok = true
        console.log(res.data[0].osspath)
        this.ticketimg = res.data[0].osspath
        this.ticketbackurl = res.data[0].osspath
        console.log(this.ticketbackurl)
        that.$message({
          type: 'success',
          message: '上传成功!'
        })
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style>
  .avatarimg6 {
    width: 50px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cardticket/KqMana.vue